import styled from '@olxui/core/dist/theme/styled';
import { P3 } from '@olxui/core/dist/core/Typography';
import { FormControl } from '@olxui/core/dist/core/FormControl';

export const NoteProgress = styled.div`
    ${({ theme }) => `
        font-size: ${theme.fontSizes[14]};
        line-height: ${theme.space[18]};
        color: ${theme.colors['$05_gray']};
        display: flex;
        justify-content: flex-end;
        width: 100%;
    `}
`;

export const StyledP3 = styled(P3)`
    padding-bottom: ${({ theme }) => theme.space[8]};
`;

export const Wrapper = styled.div<{ withMargin?: boolean }>`
    width: 100%;
    margin-bottom: ${({ theme }) => theme.space[16]};
`;

export const StyledFormControl = styled(FormControl)`
    width: 100%;
`;
